import { format, parse } from 'date-fns';
import validity from "./validity";
import defaultValue from "./defaultValue";
import { BLANK_DATE } from "./validity";
const dateStyles = {
  0: 'm/d/Y',
  1: 'd/m/Y',
  2: 'Y/m/d'
};
export const getDateFormat = style => {
  return dateStyles[style] || dateStyles[0];
};
const dateMatch = {
  'm/d/Y': 'MM/dd/yyyy',
  'd/m/Y': 'dd/MM/yyyy',
  'Y/m/d': 'yyyy/MM/dd'
};
export const translateDateFormat = dateFormat => {
  return dateMatch[dateFormat] || dateMatch[0];
};
export const formatDate = (date, style) => {
  if (date === BLANK_DATE) {
    return BLANK_DATE;
  }
  const dateFormat = translateDateFormat(getDateFormat(style));
  const matchDate = date ? parse(date, dateFormat, new Date()) : new Date();
  const formattedDate = format(matchDate, dateFormat);
  return formattedDate;
};
export default {
  validity,
  defaultValue,
  type: 'Date',
  dateStyles,
  getDateFormat,
  dateMatch,
  translateDateFormat,
  formatDate
};